import { useMutation } from '@tanstack/react-query';
import { instance } from '../api-manager';
import { apiClient } from '../api-manager-instance';
import { ENDPOINTS } from '../endpoints';

export const resetPassword = async (body: {
  password: string;
  token: string;
}) => {
  try {
    const response = await instance.post(
      "/auth/admin/reset-password",
      { password: body.password }, // ✅ password in body
      {
        headers: {
          Authorization: `Bearer ${body.token}`, // ✅ token from step2 in header
        },
      }
    );
    return { data: response.data, success: true };
  } catch (error: any) {
    return {
      success: false,
      error: error?.response?.data || error.message,
      statusCode: error?.response?.status || 500,
    };
  }
};


export const useResetPassword = () =>
  useMutation({
    mutationFn: async (body: { password: string; token: string }) => {
      const res = await apiClient.post(
        ENDPOINTS.AUTH.RESET_PASSWORD, {
        password: body.password
      }, {
        headers: {
          Authorization: `Bearer ${body.token}`,
        },
      }
      );
      return res.data;
    },
  });